import { useEffect } from 'preact/hooks'
import { connect } from 'react-redux'

import styles from 'components/styles/register.css'

import { getRegisterText } from 'selectors/register'
import { loadRegisterText } from 'actions/register'
import textListingDestruct from './textListing.destruct'

const ListingText = ({ registerText = {}, loadRegisterText }) => {
  useEffect(() => {
    loadRegisterText()
  }, [])
  const { header, items } = textListingDestruct(registerText)

  return (
    <div className={styles['listing-text']}>
      {header && <div className={styles['listing-text__header']}>{header}</div>}

      {items &&
        items.map(({ icon, title, text }, index) => (
          <div className={styles['listing-text__item']} key={index}>
            <div className={styles['listing-text__item-icon']}>
              <img src={icon} alt="" />
            </div>
            <div className={styles['listing-text__item-info']}>
              <div className={styles['listing-text__item-header']}>{title}</div>
              <div
                className={styles['listing-text__item-text']}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </div>
          </div>
        ))}
    </div>
  )
}

const mapStateToProps = state => ({
  registerText: getRegisterText(state),
})

const mapDispatchToProps = {
  loadRegisterText,
}

export default connect(mapStateToProps, mapDispatchToProps)(ListingText)
